import React, { useLayoutEffect, useRef } from "react";

/**
 * Inline-editable text that behaves like flowing text but is fully editable.
 * Auto-grows to fit content. Used across PostCard for scripts/hooks/captions/etc.
 */
export const EditableText = ({
  value = "",
  onChange,
  placeholder = "",
  className = "",
  minRows = 1,
  monospace = false,
  ariaLabel,
}) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.max(el.scrollHeight, minRows * 22) + "px";
  }, [value, minRows]);

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={ariaLabel}
      rows={minRows}
      spellCheck={true}
      className={`w-full bg-transparent resize-none outline-none border-0 p-0 text-zinc-200 placeholder:text-zinc-600 leading-relaxed transition-colors rounded-md px-2 py-1.5 -mx-2 hover:bg-zinc-950/60 focus:bg-zinc-950 focus:ring-1 focus:ring-amber-500/40 ${
        monospace ? "font-mono text-[12.5px]" : ""
      } ${className}`}
    />
  );
};

export default EditableText;
